import { Button, DatePicker, Form, Input, Modal, Select, Space } from "antd";
import { Dayjs } from "dayjs";
import { AwbStatus } from "../../enum/common";
import { ICreatePurchaseAwb } from "../../models/Purchase";
import { useCreatePurchaseAwb } from "../../query/PurchaseQuery";
import { notify } from "../../utils/toast";

interface IModalAddAwbProps {
  open: boolean;
  onClose: () => void;
  purchaseOrderId: number;
}

interface IFormData {
  awbCode: string;
  awbStatus: AwbStatus;
  eta: Dayjs | null;
  carrierCode: string;
  carrierName: string;
}

const ModalAddAwb = ({ open, onClose, purchaseOrderId }: IModalAddAwbProps) => {
  const [form] = Form.useForm();
  const createAwbMutation = useCreatePurchaseAwb();
  const handleSubmit = async (values: IFormData) => {
    try {
      if (!values.eta) {
        notify.error("Vui lòng chọn ngày dự kiến đến");
        return;
      }
      const payload: ICreatePurchaseAwb = {
        awbCode: values.awbCode,
        purchaseOrderId: purchaseOrderId,
        awbStatus: values.awbStatus,
        eta: values.eta.toDate(),
        carrierCode: values.carrierCode,
        carrierName: values.carrierName,
      };

      await createAwbMutation.mutateAsync(payload);
      notify.success("Thêm AWB thành công");
      form.resetFields();
      onClose();
    } catch (error) {
      notify.error("Lỗi khi thêm AWB");
    }
  };

  const awbStatusOptions = [
    { value: AwbStatus.CREATED, label: "Đã tạo" },
    { value: AwbStatus.PICKED_UP, label: "Đã lấy hàng" },
    { value: AwbStatus.IN_TRANSIT, label: "Đang vận chuyển" },
    { value: AwbStatus.ARRIVED_AT_HUB, label: "Đã đến hub" },
    { value: AwbStatus.OUT_FOR_DELIVERY, label: "Đang giao hàng" },
    { value: AwbStatus.DELIVERED, label: "Đã giao" },
    { value: AwbStatus.FAILED, label: "Thất bại" },
    { value: AwbStatus.RETURNED, label: "Đã trả lại" },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Thêm AWB (Air Waybill)"
      width={600}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          awbStatus: AwbStatus.CREATED,
        }}
      >
        <Form.Item
          label="Mã AWB"
          name="awbCode"
          rules={[{ required: true, message: "Vui lòng nhập mã AWB" }]}
        >
          <Input placeholder="Nhập mã AWB" size="large" />
        </Form.Item>

        <Form.Item
          label="Mã hãng vận chuyển"
          name="carrierCode"
          rules={[
            { required: true, message: "Vui lòng nhập mã hãng vận chuyển" },
          ]}
        >
          <Input placeholder="VD: DHL, FedEx, UPS" size="large" />
        </Form.Item>

        <Form.Item
          label="Tên hãng vận chuyển"
          name="carrierName"
          rules={[
            { required: true, message: "Vui lòng nhập tên hãng vận chuyển" },
          ]}
        >
          <Input placeholder="Nhập tên hãng vận chuyển" size="large" />
        </Form.Item>

        <Form.Item
          label="Trạng thái"
          name="awbStatus"
          rules={[{ required: true, message: "Vui lòng chọn trạng thái" }]}
        >
          <Select
            placeholder="Chọn trạng thái"
            size="large"
            options={awbStatusOptions}
          />
        </Form.Item>

        <Form.Item
          label="Ngày dự kiến đến (ETA)"
          name="eta"
          rules={[
            { required: true, message: "Vui lòng chọn ngày dự kiến đến" },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            placeholder="Chọn ngày dự kiến đến"
            size="large"
            format="DD/MM/YYYY"
          />
        </Form.Item>

        <Form.Item className="mb-0 flex justify-end gap-2">
          <Space>
            <Button onClick={onClose}>Hủy</Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={createAwbMutation.isPending}
            >
              Thêm AWB
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddAwb;
